import React from "react";
import {
  Edit,
  SimpleForm,
  required,
  TextInput,
  ImageInput,
  ImageField,
  NumberInput,
} from "react-admin";

export default (props) => (
  <Edit {...props} undoable={false}>
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <TextInput source="location" validate={required()} />
      <NumberInput source="height" validate={required()} />
      <NumberInput source="width" validate={required()} />
      <ImageField source="thumbnail" title="Thumbnail" />
      <ImageInput
        source="image"
        label="Image"
        accept="image/*"
        multiple={false}
        placeholder={<p>Drop your file here</p>}
        validate={required()}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Edit>
);
